import { Flex, Icon, Link, Text } from '@chakra-ui/react';
import { Section } from '@/components/shared';
import { Trans, useTranslation } from 'react-i18next';
import { ROUTE_PATHS } from '@/constants';
import { MbeInfo } from '@/components/icons';

export const CanceledShipment = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Section
      containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
      headingProps={{ mt: 0 }}
      id="recovery-password-success-section"
    >
      <Flex
        alignItems="center"
        direction="column"
        gap={6}
        px={{ base: 8, md: 16, xl: 44 }}
        py={{ base: 10, md: 24 }}
      >
        <Icon as={MbeInfo} color="brand.red.light" h={14} w={14} />
        <Text fontSize={{ base: 'h1.base', md: 'h1.mb' }} fontWeight="bold" textAlign="center">
          {t('COMMUNICATIONS.CANCELED_SHIPMENT.TITLE')}
        </Text>
        <Text fontSize={{ base: 'p.base', md: 'p.mb' }} maxW="60%" textAlign="center">
          <Trans
            components={{
              url: (
                <Link
                  color="brand.red.light"
                  fontWeight="bold"
                  href={ROUTE_PATHS.passwordRecover}
                />
              ),
            }}
            i18nKey={'COMMUNICATIONS.CANCELED_SHIPMENT.MESSAGE'}
          />
        </Text>
      </Flex>
    </Section>
  );
};
